exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2q1wqHFzPGlDo3k9Ry7Fv{max-width:440px;font-size:12px}html[dir] ._20odTU4fQ4cheP6AfFUV0o{margin-bottom:10px}html[dir] ._2nJ4qsz0qAUR6qLl9ACCuD{margin:5px 0}._2rlTkAJJ7wIb0hEbrql-2o{font-weight:600}", ""]);
// Exports
exports.locals = {
	"detailsContainer": "_2q1wqHFzPGlDo3k9Ry7Fv",
	"detailsSection": "_20odTU4fQ4cheP6AfFUV0o",
	"divider": "_2nJ4qsz0qAUR6qLl9ACCuD",
	"detailsSectionHeader": "_2rlTkAJJ7wIb0hEbrql-2o"
};